import { createAsyncThunk } from "@reduxjs/toolkit";

import { ILoginRequest, IUser } from "models/Login/login.model";
import { Login } from "services/login.service";

export const loginAsync = createAsyncThunk(
  "Login",
  async (loginReq: ILoginRequest): Promise<IUser> => {
    try {
      const response = await Login(loginReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
